export enum PaginatorTemplate {
  DEFAULT = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
  DEFAULT_TWO_PAGES = 'PrevPageLink PageLinks NextPageLink CurrentPageReport RowsPerPageDropdown',
  ACCOUNTS_PAGE = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
  ORGANIZATION_PAGE = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
  LOQ_ANNOUNCEMENT_PAGE = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
}
